import React from "react";
import { useEDASegment } from "./useEDASegment";
import Skeleton from "./components/Skeleton";
import Header from "./components/Header";
import MainTable from "./components/MainTable";
import ClassificationTable from "./components/ClassificationTable";

const EDASegment = () => {
  const {
    navigate,
    location,
    dashboard,
    selectedProcess,
    segmentTitle,
    periodOptions,
    selectedPeriod,
    setSelectedPeriod,
    selectedYear,
    setSelectedYear,
    rows,
    loading,
    error,
    selectedCategory,
    classificationLoading,
    classificationError,
    classificationData,
    monthColumns,
    transformedClassificationData,
    classificationMonths,
    segmentColumns,
    handleRowClick,
  } = useEDASegment();

  if (!location.state || !selectedPeriod) {
    return <Skeleton />;
  }

  return (
    <div className="space-y-5">
      <Header
        segmentTitle={segmentTitle}
        selectedProcess={selectedProcess}
        dashboard={dashboard}
        navigate={navigate}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        loading={loading}
        periodOptions={periodOptions}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
      />
      <MainTable
        segmentTitle={segmentTitle}
        error={error}
        monthColumns={monthColumns}
        rows={rows}
        selectedCategory={selectedCategory}
        handleRowClick={handleRowClick}
      />
      <ClassificationTable
        selectedCategory={selectedCategory}
        classificationLoading={classificationLoading}
        classificationError={classificationError}
        classificationData={classificationData}
        classificationMonths={classificationMonths}
        segmentColumns={segmentColumns}
        transformedClassificationData={transformedClassificationData}
      />
    </div>
  );
};

export default EDASegment;
